import React, {useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../../tableSettings";
import {salesTaxReturnList} from '../tableSettings';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../../common/AbstractListView";
import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../../ui/PrimaryButton';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../../framework.core/JobNames";
import {IGeneralWithList, SuntekSettings, SystemSettings} from "../../../../ifmsTypes";
import {SalesTaxReturnListItem} from '../../../../fms.data/models/SalesTaxReturnListItem';
import * as XCol from '../../../../framework.core/XExportColumn';
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { FmsSecTask } from '../../../../fms.core/constants';
import { findSecurityTaskWithBranch, getSecBySecTask } from '../../../../util';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import constants from '../../../../constants';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';
import { useJournal } from '../journal/JournalListView';
import { SecType } from '../../../../fms.enum';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as IGeneralWithList;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acSalesTaxReturn/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, `/${operation}/acSalesTaxReturn/add`, NavigationType.newPage);
  }

  async function deleteEntity() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acSalesTaxReturn/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acSalesTaxReturn/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Sales Tax Return first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.SalesTaxReturn, {
        id: selectedElement.id,
        pimsLinkId: 0
      });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acSalesTaxReturn/edit/${id}`;
    const viewUrl = `/${operation}/acSalesTaxReturn/view/${id}`;
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acSalesTaxReturn/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const editUrl = `/${operation}/acSalesTaxReturn/edit/${id}`;
    const viewUrl = `/${operation}/acSalesTaxReturn/view/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSalesTaxReturnList, selectedElement.branch);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);

  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acSalesTaxReturn/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acSalesTaxReturn/add?copyId=${id}`, NavigationType.newPage);
  }

  return {create, deleteEntity, edit, view, copy, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteEntity, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as IGeneralWithList;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSalesTaxReturnList, selectedElement?.branch);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="salesTaxReturn-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteEntity();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);

  const selectedElement = jobListContext.selectedElement as IGeneralWithList;

  const {edit, view, deleteEntity, operation} = useSelectedOperations();
  const {switchJournal} = useJournal();
  
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSalesTaxReturnList, selectedElement?.branch);

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acSalesTaxReturn/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acSalesTaxReturn/view/${id}`);
  }

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read)&& !userId.startsWith('@');
  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
      <UniqueLinkButton newStyle name='salesTaxReturn-list-add-button' /*display="primary"*/ link={`/${operation}/acSalesTaxReturn/add`} disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
      <EditIconButton2 name='salesTaxReturn-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
      <ViewIconButton2 name='salesTaxReturn-list-view-button' disabled={!hasSelectedRow} onClick={view} useText/>
      <DeleteIconButton2 name='salesTaxReturn-list-delete-button' disabled={!canBeDeleted} onClick={deleteEntity} useText/>
      </div>
        {!checkSecJournal && <JournalIconButton onClick={()=> switchJournal(JobNames.SalesTaxReturn, selectedElement.id)}useText/>}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as IGeneralWithList;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctSalesTaxReturnList, selectedElement?.branch);

  const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.SalesTaxReturn}
      jobId={(jobListContext.selectedElement as SalesTaxReturnListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function formatData(data:Array<SalesTaxReturnListItem>) {
  return data;
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as SalesTaxReturnListItem;
  // const {switchJournal} = useJournal();
  // const appContext = useContext(ApplicationContext);

  // if (!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read)&& !userId.startsWith('@')) {
  //   return null;
  // }

  // return (
  //   <JournalIconButton onClick={()=> switchJournal(JobNames.SalesTaxReturn, selectedElement.id)}useText/>
  // );
  return null;
}




/**
 * Concrete implementation for Sales Tax Return List screen
 *
 * @class SalesTaxReturnListView
 * @extends {AbstractListView}
 */
class SalesTaxReturnListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.SalesTaxReturn, 'SalesTaxReturnListItem',
    SalesTaxReturnListItem.calculateSearchParameters(search,SalesTaxReturnListItem.MapSearchFields),
    pageNum,
    limit,
    search.pageSize,
    search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.SalesTaxReturn, 'SalesTaxReturnListItem',
      SalesTaxReturnListItem.calculateSearchParameters(search,SalesTaxReturnListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getRowRenderers(Type:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return SalesTaxReturnListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      else if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      // if(x.dataIndex === "status") colRenderer.Cell = IndicatorRenderer;
      if(x.dataIndex === "status") colRenderer.Cell = TextRenderer;
      else if(x.type === XCol.XCellType.Double) colRenderer.Cell = FloatRenderer;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;

      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  salesTaxReturnList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = SalesTaxReturnListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: IGeneralWithList) {
    return row && row.id ? `/accounting/acSalesTaxReturn/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Sales Tax Return List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.SalesTaxReturn} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default SalesTaxReturnListView;
